<template>
	<template v-for="(field, index) in freetextData.config.fields" :key="index">
		<section :id="['container-' + index + '-' + field.type]" :class="['container-' + freetextData.type]">
			<div :class="{ 'container': isMultiblock == 'false' }">
				<div class="row">
					<div class="col-12 freetext">
						<h2>{{ field.title }}</h2>
						<p v-html="field.content"></p>
					</div>
				</div>
			</div>
		</section>
	</template>
</template>

<script>
export default {
	props: {
		freetextData: {
			type: Object
		},
		index: {
			type: Number
		},
		isMultiblock: {
			type: String
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-wien/freetextComponent.scss";
</style>

